import { withAuthorization } from "../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../structure/Page/DefaultPage/DefaultPage";

const ProjectsPageContent = lazy(() => import("./ProjectsPageContent"));

function ProjectsPageInternal() {
    return (
        <DefaultPage>
            <ProjectsPageContent />
        </DefaultPage>
    );
}

export const ProjectsPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN))(ProjectsPageInternal);
